


import styled from "styled-components"
import { showModal } from "../../features/modal/modalSlice"
import moment from "moment"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import {MdKeyboardArrowRight, MdKeyboardArrowDown} from "react-icons/md"
import TopPagesMapLeftSideAnimationSection from "./TopPagesMapLeftSideAnimationSection"
import { useSelector } from "react-redux"
import { setActiveTabId, setLiveStreetView } from "../../features/topPagesMap/topPagesMapSlice"
import Btn from "../shared/button/Btn"
import TopPagesTamamlananMapLeftSideContentSection from "./TopPagesTamamlananMapLeftSideContentSection"
import TopPagesTamamlananMapLeftSideAnimationSection from "./TopPagesTamamlananMapLeftSideAnimationSection"

const Container = styled.div`
            width: 400px;
            height: 100%;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 30px;
            max-height: 100%;
            overflow: auto;

            .tab-container{
                color: #000;
                width: 100%;
                height: 100px;
                display: flex;
                flex-direction: column;
                height: auto;

                .tab-item{
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;

                    .tab-item-top-container{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        border-radius: 5px;
                        padding: 8px 15px;
                        cursor: pointer;

                        h3{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                        }

                        .arr-icon{
                            font-size: 1.2rem;
                        }

                    }


                }
            }

            .btn-container{
                margin-top: auto;
                display: flex;
                justify-content: center;
            }

`

const tabList = [
    {
        id: 1,
        text: "Bilgi Ekranı"
    },
    {
        id: 2,
        text: "Geçmiş Konum Görüntüleme"
    },
]

const TopPagesTamamlananMapWideLeftSide = () => {

    const dispatch = useDispatch()
    

    const {activeTabId, topPagesMapSingleTamamlananShipmentItemLocationList} = useSelector(state => state.topPagesMap)
    const {singleShipmentLoadItem} = useSelector(state => state.loadList)

     //! bu filtrelemedeki min Tarih ve max tarih i belirleyen state ler
     const [minDate, setMinDate] = useState("")
     const [maxDate, setMaxDate] = useState("")
 
     useEffect(() => {
 
         setMinDate(topPagesMapSingleTamamlananShipmentItemLocationList[topPagesMapSingleTamamlananShipmentItemLocationList.length-1]?.createdDate?.slice(0, 16))
         setMaxDate(topPagesMapSingleTamamlananShipmentItemLocationList[0]?.createdDate.slice(0, 16))
 
     },[topPagesMapSingleTamamlananShipmentItemLocationList])

    if(topPagesMapSingleTamamlananShipmentItemLocationList?.length < 1){
        return null
    }

  return (
    <Container>

        <div className="tab-container">
            <div className="tab-item">
                <div className="tab-item-top-container" onClick={() => dispatch(setActiveTabId(activeTabId === tabList[0]?.id ? null : tabList[0].id ))}>
                    <h3>{tabList[0]?.text}</h3>
                    {
                        activeTabId === tabList[0]?.id ?
                        <MdKeyboardArrowDown  className="arr-icon"/>
                        :
                        <MdKeyboardArrowRight className="arr-icon"/>
                    }
                </div>
                {
                    activeTabId === tabList[0]?.id && <TopPagesTamamlananMapLeftSideContentSection singleShipmentLoadItem={singleShipmentLoadItem} activeTabId={activeTabId} tabId={tabList[0]?.id}/>
                }
            </div>
            <div className="tab-item">
                <div className="tab-item-top-container" onClick={() => dispatch(setActiveTabId(activeTabId === tabList[1]?.id ? null : tabList[1].id ))}>
                    <h3>{tabList[1]?.text}</h3>
                    {
                        activeTabId === tabList[1]?.id ?
                        <MdKeyboardArrowDown  className="arr-icon"/>
                        :
                        <MdKeyboardArrowRight className="arr-icon"/>
                    }
                </div>
                {
                    activeTabId === tabList[1]?.id && <TopPagesTamamlananMapLeftSideAnimationSection activeTabId={activeTabId} tabId={tabList[1]?.id} minDate={minDate} maxDate={maxDate}/>
                }
            </div>
        </div>
        <div className="btn-container">                                                                               {/* //! belki burada biraz daha fazla resetlenek veri olabilir */}
            <Btn color="#fff" bgColor="#E85446" width={"160px"} handleClick={() => {dispatch(showModal(null)); dispatch(setLiveStreetView(null))}}>Geri</Btn>
        </div>
    </Container>
  )
}

export default TopPagesTamamlananMapWideLeftSide